/**
 * @generated SignedSource<<e0f76932fa0dcd91dcc66a1892e9c4d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorPriceBreakdown_roomRate$data = {
  readonly baseCostAdult: number;
  readonly baseCostChild: number;
  readonly isPercentMarkup: boolean;
  readonly markupAmountAdult: number;
  readonly markupAmountChild: number;
  readonly markupPercentAdult: number | null;
  readonly markupPercentChild: number | null;
  readonly tripPriceAdult: number;
  readonly tripPriceChild: number;
  readonly " $fragmentType": "RoomRatesTableRateEditorPriceBreakdown_roomRate";
};
export type RoomRatesTableRateEditorPriceBreakdown_roomRate$key = {
  readonly " $data"?: RoomRatesTableRateEditorPriceBreakdown_roomRate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorPriceBreakdown_roomRate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditorPriceBreakdown_roomRate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripPriceAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tripPriceChild",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseCostAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseCostChild",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPercentMarkup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupPercentAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupPercentChild",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupAmountAdult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markupAmountChild",
      "storageKey": null
    }
  ],
  "type": "RoomRate",
  "abstractKey": null
};

(node as any).hash = "2ef0e7c19bc815a28e5f126fce735815";

export default node;
